import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { PatientPortalService } from "./patient-portal.service";

@Injectable({
  providedIn: 'root'
})
export class PatientPortalIdResolver implements Resolve<string> {
  constructor(
    private patientPortalService: PatientPortalService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    this.patientPortalService.setPatientPortalId = route.params.id;
    return of(route.params.id)

  }
}